import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedMegaphone = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="announcement" size="100%" color={stroke ?? color} />
);

export { LineRoundedMegaphone };
